module.exports = __webpack_public_path__ + "bd850c43839c757c6ebf067e6dbc0cb0.svg";